export type BudgetTopSheetViewMode = "outline" | "classic";

const STORAGE_KEY_PREFIX = "rivetai:budget-topsheet-view-mode";

export function getBudgetTopSheetViewModeStorageKey(userId: string): string {
  return `${STORAGE_KEY_PREFIX}:${userId}`;
}

export function readStoredBudgetTopSheetViewMode(
  userId: string | undefined
): BudgetTopSheetViewMode {
  if (!userId || typeof window === "undefined") return "outline";
  try {
    const raw = window.localStorage.getItem(getBudgetTopSheetViewModeStorageKey(userId));
    if (raw === "classic") return "classic";
    return "outline";
  } catch {
    return "outline";
  }
}

export function writeStoredBudgetTopSheetViewMode(
  userId: string | undefined,
  viewMode: BudgetTopSheetViewMode
): void {
  if (!userId || typeof window === "undefined") return;
  try {
    window.localStorage.setItem(getBudgetTopSheetViewModeStorageKey(userId), viewMode);
  } catch {
    /* ignore quota / private mode */
  }
}
